function Header() {
  return (
    <header className="bg-img h-[70vh] flex justify-center items-center flex-col text-white mt-[10px]">
      <h1 className="head text-[8rem] backdrop-blur-sm">Charmant Dessert</h1>
      <button className="uppercase bg-white gold p-[15px] px-[40px] hover:bg-[#aa8453] hover:text-white">
        Buy Cake
      </button>
    </header>
  );
}
export { Header };
